<div class="spinner-overlay">
    <div class="spinner">
        <span class="spinner-inner-1"></span>
        <span class="spinner-inner-2"></span>
        <span class="spinner-inner-3"></span>
    </div>
    <div class="loading-text">Cargando... Por favor, espere</div>
</div>